<crowdctrl-unauthenticated-page
  pageTitle="Can't sign you in"
  [showFooter]="false"
  defaultHref="/login"
>
  <div class="about-project">
    <crowdctrl-unauth-page-intro>
      <h1 crowdctrlUnauthIntroTitle>We don't recognise this account</h1>
      <p crowdctrlUnauthIntroLead>
        You need to use the Google account your team lead set up for you. If this isn't the right
        one, go back and try another, or ask your team lead to add this account.
      </p>
      <p crowdctrlUnauthIntroExtra class="about-project__text">
        If you're trying to get access for the first time, you can register interest or contact us.
      </p>
    </crowdctrl-unauth-page-intro>

    <ion-button
      class="about-project__submit"
      expand="block"
      fill="solid"
      color="primary"
      (click)="go($event, '/login')"
    >
      Back to sign in
    </ion-button>

    <nav class="unauthorized__nav" aria-label="Other options">
      <a
        href="/about"
        class="about-project__signin-link unauthorized__about-link"
        (click)="go($event, '/about')"
      >
        How it works
        <ion-icon
          name="arrow-forward-outline"
          aria-hidden="true"
          class="unauthorized__about-link__arrow"
        ></ion-icon>
      </a>
      <a
        href="/register-interest"
        class="about-project__signin-link"
        (click)="go($event, '/register-interest')"
        >Register interest</a
      >
      <a href="/contact" class="about-project__signin-link" (click)="go($event, '/contact')"
        >Contact us</a
      >
    </nav>
  </div>
</crowdctrl-unauthenticated-page>
